import {
    InfoHint,
    InfoHintBody,
    InfoHintContent,
    InfoHintHeader,
    InfoHintTitle,
    InfoHintTrigger,
} from '@plato/ui/components/info-hint';
import { cn } from '@plato/ui/util/classes';
import * as Collapsible from '@radix-ui/react-collapsible';
import { ChevronUp } from 'lucide-react';
import type React from 'react';
import { useState } from 'react';
import { Text } from './text.tsx';

type Props = {
    title: string;
    defaultOpen?: boolean;
    tooltipText?: string;
    className?: string;
} & React.PropsWithChildren;

export function CollapsibleContainer({
    defaultOpen = false,
    tooltipText,
    title,
    children,
    className,
}: Props) {
    const [isOpen, setIsOpen] = useState(defaultOpen);

    return (
        <Collapsible.Root
            defaultOpen={defaultOpen}
            open={isOpen}
            onOpenChange={setIsOpen}
            className={className}
        >
            <Collapsible.Trigger>
                <span className="flex flex-row items-center">
                    <span
                        style={{ transformOrigin: 'center' }}
                        className={cn('p-2 duration-200', {
                            'rotate-180': isOpen,
                        })}
                    >
                        <ChevronUp />
                    </span>
                    <div className="flex flex-row gap-x-2 items-center">
                        <Text>{title}</Text>
                        {tooltipText && (
                            <InfoHint>
                                <InfoHintTrigger />
                                <InfoHintContent side="right">
                                    <InfoHintHeader>
                                        <InfoHintTitle>{title}</InfoHintTitle>
                                    </InfoHintHeader>
                                    <InfoHintBody>{tooltipText}</InfoHintBody>
                                </InfoHintContent>
                            </InfoHint>
                        )}
                    </div>
                </span>
            </Collapsible.Trigger>
            <Collapsible.Content>{children}</Collapsible.Content>
        </Collapsible.Root>
    );
}
